<script setup lang="ts">
import { ref, defineProps, onMounted } from "vue";
import { useOperationStore } from "@/stores/operation";
const operationStore = useOperationStore();
import NoticeView from "@/components/NoticeFormView.vue";

const server = process.env.VUE_APP_ROOT_API ?? "https://api-gabarit.promo.dev";
const loading = ref<boolean>(false);
const hiderror = ref<boolean>(true);
const relay = ref<object>({});
const message = ref<string>("");
const sendedToApi = ref(false);
const reactivity = ref(true);

// eslint-disable-next-line no-undef
const props = defineProps({
  status: {
    type: String,
    required: true,
  },
});

const notice = ref(false);
const filteredForms = (lang: string | undefined) => {
  if (Array.isArray(operationStore.operationData?.forms)) {
    const form = operationStore.operationData?.forms?.filter((form) => {
      return form.type == "CREATE" && form.lang == lang && !form.line_item;
    });

    if (!form || form.length === 0) {
      message.value = "FormId not found";
      return [];
    }
    return form[0]._id;
  }
  return [];
};

const getResult = (result: Array<unknown>) => {
  loading.value = false;

  if (result) {
    sendedToApi.value = true;
    // setTimeout(() => {
    //   sendedToApi.value = false;
    // }, 10000);
  }
};

const onLoading = () => {
  loading.value = true;
};

const showErrorForm = (event?: {
  error: string[] | { message: string };
  errorId: string;
}) => {
  if (!event) {
    return;
  }
  if (
    event.error &&
    Array.isArray(event.error) &&
    event.error.length > 0 &&
    (event.error[0] == "Email domain not allowed" ||
      event.error[0] == "Email address with + character not allowed")
  ) {
    alert(
      "L'adresse email que vous avez saisie n'est pas autorisée ou invalide. Veuillez utiliser une adresse email valide."
    );
    return;
  }
  loading.value = false;
  // message.value = showError(event) as string;
  return message.value;
};

const formId = ref(filteredForms("fr"));

//import { defineEmits } from "vue";
//const emit = defineEmits(["direction", "update"]);

//const bannerDirection = () => {
//  emit("direction", "right");
//};
//const fullOpen = () => {
//  emit("direction", "fullopen");
//};

const checkRgpd = () => {
  setTimeout(() => {
    const noticelink = document.querySelector("#noticelink");
    if (noticelink) {
      noticelink.addEventListener("click", (event) => {
        event.preventDefault();
        notice.value = true;
      });
    }
  }, 1000);
};

onMounted(() => {
  checkRgpd();
});

const closeNotice = () => {
  notice.value = false;
  checkRgpd();
};
</script>
<template>
  <div class="gabarit_create relative h-full">
    <div
      v-if="notice"
      class="inset-0 h-full w-full bg-primary-bg text-primary-text overflow-auto absolute p-4"
    >
      <NoticeView />
      <p class="text-center mt-4 py-2">
        <button @click="closeNotice" class="button">
          {{ $t("done.button") }}
        </button>
      </p>
    </div>

    <div>
      <Form
        v-if="
          !sendedToApi &&
          operationStore.operationData?._id &&
          reactivity &&
          props.status == 'open'
        "
        class="form_step pb-4"
        id="createForm"
        :form_id="formId"
        :server="server"
        v-on:results="getResult"
        v-on:form_submit_loading="onLoading"
        :hideError="hiderror"
        @on_error="showErrorForm"
        :relay="relay"
      />

      <div v-if="sendedToApi">
        <h1 class="mt-6 w-full text-center">Félicitations !<br /></h1>
        <div
          v-if="operationStore.operationData?.custom?.text_submited"
          v-html="operationStore.operationData?.custom?.text_submited"
        />
        <div
          v-else
          class="h-full flex items-center justify-center w-full text-primary-text"
        >
          <div>
            <div class="w-full text-center pt-8">
              <i
                class="floating-div fa-regular text-green-500 fa-circle-check text-[90px] m-auto"
              ></i>
            </div>

            <h2 class="text-2xl font-bold text-center w-full pt-8">
              Félicitations !
            </h2>
            <p class="py-6 max-w-sm m-auto text-justify">
              Votre compte a été créé avec succès ! Un email contenant le lien
              pour accéder à votre espace personnel vient de vous être envoyé.
            </p>
          </div>
        </div>
      </div>

      <p v-if="!sendedToApi" class="text-xs italic text-gray-600 pl-5 pb-4">
        <a
          href="https://oxoformdocs.fra1.digitaloceanspaces.com/6746f70c439fbc9c810444fd/reglement.pdf"
          target="_blank"
          ><sup>(1)</sup> Voir le règlement</a
        >
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
h1 {
  @apply text-2xl uppercase font-bold;
  background: linear-gradient(
    270deg,
    rgba(24, 155, 196, 1) 0%,
    rgba(61, 128, 172, 1) 31%,
    rgba(231, 42, 56, 1) 72%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.slide-left {
  transform: translateX(-100%);
}

.slide-right {
  transform: translateX(100%);
}

.slide-right.slide-reset,
.slide-left.slide-reset {
  transform: translateX(0%);
}

/* Animations de transition */

.slide-leave-active,
.slide-enter-active {
  transition: 0.2s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}
</style>
